<script>
import { required } from "vuelidate/lib/validators";
import { layoutMethods, erpUserRolesMethods, exportMethods, coreEloadDropdownMethods, coreEloadDropdownComputed, coreEloadSKUMainMethods, coreEloadSKUMainComputed } from '@/state/helpers';
import Swal from 'sweetalert2';
import { getModuleAccess } from '@/router/helper.js'
import Multiselect from "vue-multiselect";

/**
 * E-Load list component
 */
export default {
  page: {
    title: "E-Load SKU Form",
  },
  data() {
    return {
      promoId: 0,
      eload: {
        promoId: "",
        name: "",
        code: "",
        validity: "",
        amount: "",
        description: "",
        provider: null,
        networkGroup: null,
        category: "",
        categoryIds: [],
        categoryNames: [],
        status: 1,
        service: null,
        error: "",
        input_type: null,
        minimum: null,
        maximum: null,
      },
      formExitChecker : {
        promoId: "",
        name: "",
        code: "",
        validity: "",
        amount: "",
        description: "",
        provider: null,
        networkGroup: null,
        category: "",
        categoryIds: [],
        categoryNames: [],
        status: 1,
        service: null,
        error: "",
        input_type: null,
        minimum: null,
        maximum: null,
      },
      options: [
        { value: "GLOBE", text: "Globe" },
        { value: "TM", text: "TM" },
        { value: "SMART", text: "Smart" },
        { value: "DITO", text: "DITO" },
      ],
      submitted: false,
      eloadPromoModule: {
        access: {
          create: true,
          update: true
        }
      },
      categoryList: [],
      eloadServiceOptions: [],
      providerList: [],
      eloadNetworkGroupOptions: [],
      inputTypeList: [
        { value: null, text: 'Select Input Type', disabled: true },
        { value: "MN", text: 'Mobile Number'},
        { value: "AN", text: 'Account Number'}
      ],
      inputTypeHandler: null,
      selectedSKUMaster: null,
      skuMasterOptions: [],
    };
  },
  validations() {
    if (this.promoId > 0) {
      return {
        eload: {
          status: {required}
        }
      };
    }
    return {
      selectedSKUMaster: {required},
      eload: {
        status: {required}
      }
    };
  },
  components: {
    Multiselect
  },
  computed: {
    ...coreEloadDropdownComputed,
    ...coreEloadSKUMainComputed,
    
  },
  mounted: async function() {
    this.promoId = this.$route.params.id;
        
    // if(this.promoId == 0) { // Disable Create Eload promo page - PEDDLR-6704
    //   this.$router.push(
    //       this.$route.query.redirectFrom || {
    //         name: "E-Load",
    //       }
    //     );
    //     return;
    // }

    
    await this.getEloadCategoryList();
    await this.getEloadServiceList();
    await this.getEloadProviderList();
    await this.getNetworkGroups();
    
    // Fetch unlisted SKU list for add mode
    if (this.promoId == 0) {
      await this.getUnlistedSKUList();
    }

    this.changeTitle({title: (this.promoId > 0 ? "E-Load SKU View" : "Add E-Load SKU")});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'}},
        { text: 'E-Load Core Manager', to: { name: 'E-Load Core SKU'} },
        { text: 'E-Load SKU Form', to: { name: 'E-Load Core SKU Form'} }
      ]
    });
    if (this.promoId > 0) {
      await this.editPromo();
    }

    await getModuleAccess('Products', 'eLoad', 'eLoad Promo')
      .then((access) => this.eloadPromoModule.access = access);
  },
  methods: {
    ...layoutMethods,
    ...erpUserRolesMethods,
    ...coreEloadDropdownMethods,
    ...coreEloadSKUMainMethods,
    ...coreEloadSKUMainMethods,
    ...exportMethods,
    async getEloadProviderList() {
        this.fetchCoreProvidersList().then(async () => {
          let sortedList = await this.sortOptions('name', [...this.getCoreProvidersList]);
          for (let provider of sortedList) {
            this.providerList.push({ text: provider.name, value: provider.name })
          }
        });
    },
    async getEloadCategoryList() {
      this.fetchCoreCategoriesList().then(async () => {
        let sortedList = await this.sortOptions('category', [...this.getCoreCategoriesList]);
        for(let data of sortedList){
          this.categoryList.push({ 'text': data.category, 'value': data.category })
        }
      })
    },
     async getEloadServiceList() {
      this.fetchCoreServicesList().then(async () => {
        let sortedList = await this.sortOptions('service', [...this.getCoreServicesList]);
        for (let service of sortedList) {
          this.eloadServiceOptions.push({ text: service.service, value: service.service })
        }
      });
    },
    async getNetworkGroups() {
      this.fetchCoreNetworksList().then(async () => {
        let sortedList = await this.sortOptions('name', JSON.parse(JSON.stringify(this.getCoreNetworksList)));
        for (let group of sortedList) {
          this.eloadNetworkGroupOptions.push({ text: group.name, value: group.name })
        }
      });
    },
    async getUnlistedSKUList() {
      try {
        await this.fetchCoreUnlistedSKUList({all_column: true});
        const unlistedSKUs = this.getCoreUnlistedSKUList || [];
        console.log('Unlisted SKUs from API:', unlistedSKUs);
        
        this.skuMasterOptions = unlistedSKUs.map(sku => ({
          id: sku.id,
          name: sku.sku_name,
          code: sku.sku_code,
          service: sku.service,
          networkGroup: sku.service_group,
          provider: sku.providerName,
          category: sku.category,
          amount: sku.amount,
          validity: sku.validity,
          description: sku.description,
          inputType: sku.address_type || 'MN',
          minimum: sku.address_min || '11',
          maximum: sku.address_max || '11'
        }));
        
        console.log('SKU Main Options:', this.skuMasterOptions);
      } catch (error) {
        console.error('Error fetching unlisted SKU list:', error);
      }
    },
    onSKUMasterSelect(selectedSKU) {
      if (!selectedSKU) {
        this.clearForm();
        return;
      }
      
      // Auto-fill form with selected SKU data
      this.eload.name = selectedSKU.name;
      this.eload.code = selectedSKU.code;
      this.eload.service = selectedSKU.service;
      this.eload.networkGroup = selectedSKU.networkGroup;
      
      // Provider is already a name string from API
      this.eload.provider = selectedSKU.provider;
      
      this.eload.category = selectedSKU.category;
      this.eload.categoryNames = [selectedSKU.category];
      this.eload.amount = selectedSKU.amount;
      this.eload.validity = selectedSKU.validity;
      this.eload.description = selectedSKU.description;
      this.eload.input_type = selectedSKU.inputType;
      this.eload.minimum = selectedSKU.minimum;
      this.eload.maximum = selectedSKU.maximum;
    },
    async handleSubmit() {
      var action = this.promoId == 0 ? "add":"update";
      this.submitted = true
      this.$v.$touch();
      
      // For add mode, validate SKU Master selection
      if (this.promoId == 0 && !this.selectedSKUMaster) {
        this.$alertify.error("Please select a SKU Master.");
        return;
      }
      
      if (!this.$v.$invalid){
        let status = this.eload.status ? 1 : 0;
        
        // For add mode, use selectedSKUMaster data
        // For update mode, use eload data
        const skuData = action === "add" ? this.selectedSKUMaster : this.eload;
        const skuName = action === 'add' ? this.selectedSKUMaster.name : this.eload.name;
        
        let body = {
          skuId: action === "add" ? String(skuData.id) : String(skuData.promoId),
          status: String(status)
        };

        this.actionCoreEloadSKUMainAPIPOST({
          action: action,
          params: body
        })
          .then((response) => {
            // Check if API returned error status
            if (response.status === 'err') {
              this.submitted = false;
              this.$alertify.error(response.message || 'Operation failed');
              Swal.fire(
                ((action == 'add') ? "Add":"Update")+" Failed!",
                response.message || 'An error occurred',
                "warning"
              );
              return;
            }
            
            // Success case (status === 'ok')
            this.submitted = false;
            var applied_action = (action == 'add') ? "added" : "updated";
            Swal.fire(
               ((action == 'add') ? "Add":"Update")+" Successful!",
              `${skuName} is successfully ${applied_action} to the SKU list.`,
              "success"
            ).then(() => {
              this.clearForm();
              this.$router.go(-1);
              return;
            });
          })
          .catch((error) => {
            console.log(error);
            const errorMsg = error && error.message ? error.message : (typeof error === 'string' ? error : 'An unexpected error occurred');
            this.$alertify.error(errorMsg);
            Swal.fire(
              ((action == 'add') ? "Add":"Update")+" Failed!",
              errorMsg,
              "warning"
            );
            this.submitted = false;
            return;
          });
      }
      else {
        this.$alertify.error("Unable to submit, please check the required fields and try again.");
        return;
      }
    },
    async editPromo() {
      await this.actionCoreEloadSKUMainAPIPOST({action: "info", params: {"skuId" : this.promoId}}).then((response) => {
        const data = response.message;

        if(response.status == 'err'){
          this.$alertify.error(data.message || 'Failed to fetch promo details.');
          this.$router.go(-1);
          return;
        }

        if(data.message || Object.keys(data).length === 0){
          this.$alertify.error('Promo not found.');
          this.$router.go(-1);
          return;
        }
        
        this.eload.promoId = data.skuId
        this.eload.name = data.skuName
        this.eload.code = data.skuCode
        this.eload.amount = data.skuAmount
        this.eload.description = data.skuDescription
        this.eload.validity = data.skuValidity
        this.eload.status = parseInt(data.skuStatus)
        this.eload.category = data.skuCategory
        this.eload.categoryIds = []
        this.eload.categoryNames = [data.skuCategory]
        this.eload.networkGroup = data.serviceGroup
        this.eload.service = data.skuService
        this.eload.input_type = data.addressType
        this.eload.minimum = data.minimum
        this.eload.maximum = data.maximum
        
        // Find provider name from provider ID
        const providerObj = this.getCoreProvidersList.find(p => p.id === data.provider);
        this.eload.provider = providerObj ? providerObj.name : null;
        
        // Set selectedSKUMaster for display in edit mode
        this.selectedSKUMaster = {
          id: data.skuId,
          name: data.skuName
        };

        this.formExitChecker.promoId = data.skuId
        this.formExitChecker.name = data.skuName
        this.formExitChecker.code = data.skuCode
        this.formExitChecker.amount = data.skuAmount
        this.formExitChecker.description = data.skuDescription
        this.formExitChecker.validity = data.skuValidity
        this.formExitChecker.provider = providerObj ? providerObj.name : null
        this.formExitChecker.status = parseInt(data.skuStatus)
        this.formExitChecker.category = data.skuCategory
        this.formExitChecker.categoryIds = []
        this.formExitChecker.categoryNames = [data.skuCategory]
        this.formExitChecker.networkGroup = data.serviceGroup 
        this.formExitChecker.service = data.skuService
        this.formExitChecker.input_type = data.addressType
        this.formExitChecker.minimum = data.minimum
        this.formExitChecker.maximum = data.maximum

        console.log(">> API Response:",response);
        console.log(">> Parsed Data:",data);
        console.log(">> eload:",this.eload);
        console.log(">> formExitChecker:",this.formExitChecker);
      });
    },
    leaveform(next){
        if(JSON.stringify(this.eload) == JSON.stringify(this.formExitChecker)){
          next();
          return;
        }
        Swal.fire({
            title: 'Are you sure?',
            text: "you want to leave this page?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#804997',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                next();
            }else{
                return;
            }
        })
    },
    clearForm(){
      this.eload = {
        promoId: "",
        name: "",
        code: "",
        validity: "",
        amount: "",
        description: "",
        provider: null,
        networkGroup: null,
        category: "",
        categoryIds: [],
        categoryNames: [],
        status: 0,
        service: null,
        error: "",
        input_type: null,
        minimum: null,
        maximum: null,
      }
      this.selectedSKUMaster = null;
      this.formExitChecker = this.eload;
    },
    async sortOptions(propName, arr) {
      arr.sort((a, b) => {
        const nameA = a[`${propName}`].toUpperCase();
        const nameB = b[`${propName}`].toUpperCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      return arr;
    },
    async toggleSKUStatus(event) {
      // Prevent default behavior
      event.preventDefault();
      
      // Store the original status before change
      const originalStatus = this.eload.status;
      const newStatus = originalStatus == 1 ? 0 : 1;
      const statusText = newStatus == 1 ? 'activate' : 'deactivate';
      
      Swal.fire({
        title: 'Are you sure?',
        text: `Do you really want to ${statusText} this SKU?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#804997',
        cancelButtonColor: '#dc3545',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.isConfirmed) {
          this.actionCoreEloadSKUMainAPIPOST({
            params: {
              skuId: this.eload.promoId,
              status: String(newStatus)
            },
            action: "update"
          })
          .then((res) => {
            if (res.status === 'err') {
              this.$alertify.error(res.message || 'Update failed');
              Swal.fire(
                'Update Failed!',
                res.message || 'An error occurred',
                'warning'
              );
              return;
            }
            
            // Update the status locally
            this.eload.status = newStatus;
            this.formExitChecker.status = newStatus;
            
            Swal.fire({
              title: 'Updated Successful!',
              text: `${this.eload.name} is successfully ${statusText}d.`,
              icon: 'success',
              confirmButtonColor: '#804997',
              confirmButtonText: 'OK'
            }).then(() => {
              this.$router.go(-1);
            });
          })
          .catch((error) => {
            console.error(error);
            const errorMsg = error && error.message ? error.message : 'An error occurred';
            this.$alertify.error(errorMsg);
            Swal.fire(
              'Update Failed!',
              errorMsg,
              'warning'
            );
            event.target.checked = originalStatus == 1;
          });
        } else {
          event.target.checked = originalStatus == 1;
          this.eload.status = originalStatus;
        }
      });
    },
  },
  beforeRouteLeave(to, from, next) {
      if(this.promoId > 0) {
        console.log("><><><><> HEY",JSON.stringify(this.eload),JSON.stringify(this.formExitChecker));
        this.leaveform(next);
      }
      else next(); // Disable create page for eload promo - PEDDLR-6704
  }
};
</script>

<template>
  <div class="row sku-main-form-page">
    <div class="col-lg-8">
      <div class="card">
        <div class="card-body">
          <form class="px-4 py-3" @submit.prevent="handleSubmit()">
            <div class="row">
              <label v-if="(promoId <= 0 || isNaN(promoId)) && !eloadPromoModule.access.create" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot create a promo.</label>
              <label v-else-if="promoId > 0 && !eloadPromoModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a promo.</label>
            </div>
            
            <!-- Activate Toggle -->
            <div class="row mb-3">
              <div class="col-12">
                <div class="form-check form-switch form-switch-lg" dir="ltr">
                  <input
                    v-if="promoId > 0"
                    type="checkbox"
                    class="form-check-input"
                    id="customSwitchsizem"
                    :checked="eload.status == 1"
                    @change="toggleSKUStatus($event)"
                  />
                  <input
                    v-else
                    type="checkbox"
                    class="form-check-input"
                    id="customSwitchsizem"
                    v-model="eload.status"
                    :checked="eload.status == 1"
                  />
                  <label class="form-check-label form-label fw-bold" for="customSwitchsizem">Active</label>
                </div>
              </div>
            </div>

            <!-- SKU Master Dropdown -->
            <div class="row mb-3">
              <div class="col-md-6">
                <label class="form-label fw-bold">SKU Master<span v-if="promoId == 0" style="color: red">*</span></label>
                <multiselect
                  v-model="selectedSKUMaster"
                  :options="skuMasterOptions"
                  track-by="id"
                  label="name"
                  placeholder="Select SKU Master"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  :allow-empty="false"
                  :show-labels="false"
                  :disabled="promoId > 0"
                  @input="onSKUMasterSelect"
                  :class="{'is-invalid': submitted && $v.selectedSKUMaster && $v.selectedSKUMaster.$error}">
                </multiselect>
                <div v-if="submitted && promoId == 0 && $v.selectedSKUMaster && !$v.selectedSKUMaster.required" class="text-danger small mt-1">
                  SKU Master is required.
                </div>
              </div>
              
              <div class="col-md-6">
                <label class="form-label fw-bold">Promo ID</label>
                <input
                  type="text"
                  class="form-control"
                  :value="promoId > 0 ? eload.promoId : (selectedSKUMaster ? selectedSKUMaster.id : '')"
                  readonly
                  disabled
                  :placeholder="promoId == 0 ? 'Promo ID' : ''"/>
              </div>
            </div>

            <!-- Service and Network Row -->
            <div class="row">
              <div class="col-md-4 mb-3">
                <label class="form-label fw-bold">Service</label>
                <div class="form-control-plaintext">{{ eload.service || '--' }}</div>
              </div>

              <div class="col-md-4 mb-3">
                <label class="form-label fw-bold">Network</label>
                <div class="form-control-plaintext">{{ eload.networkGroup || '--' }}</div>
              </div>

              <div class="col-md-4 mb-3">
                <label class="form-label fw-bold">Provider</label>
                <div class="form-control-plaintext">{{ eload.provider || '--' }}</div>
              </div>
            </div>

            <!-- Category and Promo Name Row -->
            <div class="row">
              <div class="col-md-4 mb-3">
                <label class="form-label fw-bold">Category</label>
                <div class="form-control-plaintext">{{ eload.category || '--' }}</div>
              </div>

              <div class="col-md-4 mb-3">
                <label class="form-label fw-bold">Promo Name</label>
                <div class="form-control-plaintext">{{ eload.name || '--' }}</div>
              </div>

              <div class="col-md-4 mb-3">
                <label class="form-label fw-bold">Promo Code</label>
                <div class="form-control-plaintext">{{ eload.code || '--' }}</div>
              </div>
            </div>

            <!-- Input Type, Amount, and Validity Row -->
            <div class="row">
              <div class="col-md-4 mb-3">
                <label class="form-label fw-bold">Input Type</label>
                <div class="form-control-plaintext">{{ eload.input_type === 'MN' ? 'Mobile Number' : eload.input_type === 'AN' ? 'Account Number' : '--' }}</div>
              </div>

              <div class="col-md-4 mb-3">
                <label class="form-label fw-bold">Amount</label>
                <div class="form-control-plaintext">{{ eload.amount ? 'PHP ' + eload.amount : '--' }}</div>
              </div>

              <div class="col-md-4 mb-3">
                <label class="form-label fw-bold">Validity</label>
                <div class="form-control-plaintext">{{ eload.validity || '--' }}</div>
              </div>
            </div>

            <!-- Description Row -->
            <div class="row">
              <div class="col-md-12 mb-3">
                <label class="form-label fw-bold">Description</label>
                <div class="form-control-plaintext">{{ eload.description || '--' }}</div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div v-if="promoId == 0" class="text-end mt-4">
              <b-button 
                :disabled="!this.eloadPromoModule.access.create" 
                variant="primary" 
                class="w-sm" 
                type="submit">
                  Save
              </b-button>
              <router-link :to="{ name: 'E-Load Core SKU', params: {} }" class="tc-white">
                <b-button variant="light" class="w-sm ms-2" type="button">Cancel</b-button>
              </router-link>
              <p v-if="eload.error" class="text-danger">{{ eload.error }}</p>
            </div>
            
            <!-- Back Button for Edit Mode -->
            <div v-else class="text-end mt-4">
              <router-link :to="{ name: 'E-Load Core SKU', params: {} }" class="tc-white">
                <b-button variant="light" class="w-sm" type="button">Back</b-button>
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.disabled-text {
  color: gray;
}

.sku-main-form-page .multiselect.is-invalid .multiselect__tags {
  border-color: #dc3545 !important;
}

.sku-main-form-page .multiselect.is-invalid ~ .invalid-feedback {
  display: block;
}

.sku-main-form-page .multiselect--active .multiselect__tags {
  padding: 6px 40px 6px 8px;
}

.sku-main-form-page .multiselect__tags {
  min-height: 38px;
  display: flex;
  align-items: center;
  padding: 6px 8px;
  font-size: 1rem;
}

.sku-main-form-page .multiselect__single {
  background: transparent !important;
  color: #202020;
  padding: 2px 5px 2px 5px;
  border-radius: 4px;
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  position: relative;
  min-height: auto;
  line-height: 1.4;
  width: fit-content;
  max-width: 100%;
}

.sku-main-form-page .multiselect__option--selected {
  font-weight: 600;
}

.sku-main-form-page .multiselect__option--selected:after {
  display: none;
}

.sku-main-form-page .multiselect__tags-wrap {
  display: inline-flex;
  align-items: center;
}

.sku-main-form-page .multiselect__tag-divider {
  display: inline-block;
  width: 1px;
  height: 18px;
  background-color: rgba(255, 255, 255, 0.3);
  margin: 0 0px 0 8px;
}

.sku-main-form-page .multiselect__tag-icon {
  position: relative;
  cursor: pointer;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  border-radius: 50%;
  background: transparent;
  transition: background 0.2s ease;
  right: auto;
  top: auto;
  transform: none;
  /* margin-right: 2px; */
}

.sku-main-form-page .multiselect__tag-icon:after {
  content: "×";
  color: white;
  font-size: 20px;
  font-weight: bold;
  line-height: 18px;
}

.sku-main-form-page .multiselect__tag-icon:hover {
  background: rgba(255, 255, 255, 0.2);
}

.sku-main-form-page .multiselect__tag-icon:focus {
  outline: none;
}

.sku-main-form-page .multiselect__placeholder {
  color: #6c757d;
  margin-bottom: 0;
  padding-top: 0;
  display: inline-block;
  padding-left: 4px;
  font-size: 1rem;
}

.sku-main-form-page .multiselect__select {
  right: 8px;
  width: 30px;
  height: 30px;
  top: 50%;
  transform: translateY(-50%);
}

.sku-main-form-page .multiselect__option--highlight {
  background: #EDEDED !important;
  color: #333 !important;
}

.sku-main-form-page .multiselect__option--highlight:after {
  background: #EDEDED !important;
}

.sku-main-form-page .multiselect--disabled .multiselect__tags {
  background: #f5f6f8;
}
.sku-main-form-page .multiselect--disabled .multiselect__single {
  background: #f5f6f8;
}

.sku-main-form-page .multiselect--disabled .multiselect__select {
  display: none;
}
</style>